import SeoLandingLayout from "../../components/SeoLandingLayout";

export default function JewelleryManufacturerMeerut() {
  return (
    <SeoLandingLayout
      testId="manufacturer-meerut-page"
      path="/jewellery-manufacturer-meerut"
      seoTitle="Jewellery Manufacturer in Meerut | Craft & Product Development | Ramesh Kapoor & Sons"
      seoDescription="Jewellery manufacturing and product development in Meerut — craftsmanship, finishing and design discipline behind Ramesh Kapoor & Sons Jewellers' wholesale and retail collections."
      crumbLabel="Jewellery Manufacturer Meerut"
      eyebrow="The Bench Behind the Brand"
      h1={<>Jewellery Manufacturing in <span className="italic text-[#C5A059]">Meerut</span></>}
      intro={[
        "Behind the wholesale desks and the retail showroom of Ramesh Kapoor & Sons Jewellers Pvt. Ltd. sits the discipline that decides everything else: how a piece is made. Manufacturing and product development are part of the same family business that supplies jewellers across Uttar Pradesh and serves families at our Meerut showroom.",
        "This page explains how we think about making jewellery — workmanship, finishing and design development — without ceremony and without exaggeration.",
      ]}
      hero={{ src: "/images/jewellery-craft.jpg", alt: "A goldsmith's hands crafting a gold bangle at the workbench — jewellery manufacturing at Ramesh Kapoor & Sons, Meerut" }}
      sections={[
        {
          id: "at-the-bench",
          eyebrow: "Workmanship",
          title: "Judged at the Bench, Not the Counter",
          paragraphs: [
            "A jewel reveals its making in the small places: the inside of a bangle, the back of a pendant, the joint of a clasp. Our manufacturing work centres on clean casting and filing, secure stone setting, consistent polishing and finishing — the unglamorous disciplines that decide whether a piece feels ordinary or considered in the hand.",
            "These standards apply equally to a single retail piece and to a wholesale line of two hundred. A retailer who reorders by product code should receive the same finish as the first piece they took.",
          ],
        },
        {
          id: "product-development",
          eyebrow: "Development",
          title: "From Counter Insight to New Designs",
          paragraphs: [
            "New designs begin with what jewellers and families actually report: wearable weights, price points that move, occasions that are underserved, and fashions worth following — or worth ignoring. Because our wholesale desk hears from retail counters across the region every week, product development is guided by real demand rather than catalogues copied from elsewhere.",
            "Each design is then worked through construction: how it will be worn, where it will strain, how it will be repaired if needed, and how it will be weighed and priced honestly at the counter.",
          ],
        },
        {
          id: "finishing",
          eyebrow: "Durability",
          title: "Finishing Built for Daily Wear",
          paragraphs: [
            "Much of what we make is worn daily, not occasionally. Clasps, hinges, links and settings are therefore treated as engineering, not decoration — chosen and finished to survive years of ordinary use. It is a quiet discipline, refined across five decades of the family's work in the trade.",
          ],
        },
        {
          id: "for-buyers",
          eyebrow: "What It Means",
          title: "What Manufacturing Means for Buyers",
          paragraphs: [
            "For jewellers, in-house manufacturing and development mean a shorter line between the bench and the trade desk: consistent finish across reorders, designs developed against real retail demand, and direct accountability when something needs adjustment.",
            "For families at our showroom, it means the piece in the glass case was made to the same standard our wholesale buyers expect — because the same standards produced both.",
          ],
        },
      ]}
      faqs={[
        { q: "Does Ramesh Kapoor & Sons manufacture its own jewellery?", a: "Manufacturing and product development are part of our business, alongside wholesale and retail. The workmanship standards described on this page run through everything we supply." },
        { q: "Can jewellers request specific designs or weight ranges?", a: "Yes. Wholesale buyers regularly discuss design direction and weight ranges with our trade desk, and product development is shaped by what retail counters report." },
        { q: "What should I look at to judge a piece's workmanship?", a: "Turn it over. Look at the inside surfaces, the setting of the stones, the clasp or hinge, and the evenness of the polish. Our team will show you these points at the counter or the wholesale desk." },
        { q: "Do you make bridal or custom pieces?", a: "Bridal sets are a core part of our range, and preferences on design and weight can be discussed during a showroom appointment at Abu Plaza, Meerut, or through the wholesale desk for trade buyers." },
        { q: "Where is the manufacturing based?", a: "Our business is rooted in Meerut, Uttar Pradesh, with our flagship operations in Sarafa Bazaar. Visit us to discuss manufacturing, wholesale or retail requirements in person." },
      ]}
      cta={{
        title: <>See the workmanship <span className="italic text-[#C5A059]">in person.</span></>,
        buttons: [
          { to: "/jewellery/wholesale", label: "Wholesale Desk", primary: true },
          { to: "/jewellery/appointment", label: "Book a Showroom Visit" },
        ],
      }}
      siblings={[
        { to: "/wholesale-jewellery-meerut", label: "Wholesale jewellery in Meerut" },
        { to: "/jewellery-meerut", label: "Jewellery in Meerut — overview" },
        { to: "/bridal-jewellery-meerut", label: "Bridal jewellery in Meerut" },
      ]}
    />
  );
}
